module.exports = __webpack_public_path__ + "static/media/i_foto.2325273b.svg";